<script>
    import { fade } from "svelte/transition";
    import { LinkedinSolid } from "flowbite-svelte-icons";

    export let image = null;
    export let linkedin = "";
    export let name;
    export let position = "";
    export let company = "";
    export let company_image = null;
</script>

<div in:fade class="flex flex-col md:flex-row gap-6 md:gap-14 items-center md:items-start overflow-hidden rounded-[8px] p-6 md:p-14" style="background-color: #f6f5f2;">
    <!-- Left: profile (shrink-0, width by content) -->
    <div class="flex flex-col gap-4 md:gap-6 items-center md:items-start flex-shrink-0">
        {#if image}
            <div class="w-[120px] h-[120px] md:w-[200px] md:h-[200px] rounded-full overflow-hidden">
                <img src={image} alt={name} class="w-full h-full object-cover" />
            </div>
        {:else if company_image}
            <div class="w-[120px] h-[120px] md:w-[200px] md:h-[200px] rounded-[12px] overflow-hidden flex items-center justify-center" style="background-color: #f6f5f2;">
                <img src={company_image} alt={company} class="w-full h-full object-contain" style="mix-blend-mode: multiply;" />
            </div>
        {/if}

        <div class="flex flex-col gap-3 items-start">
            {#if name}
                <span class="text-[20px] font-medium text-navy leading-snug">{name}</span>
            {:else if company}
                <span class="text-[20px] font-medium text-navy">{company}</span>
            {/if}
            {#if position}
                <p class="text-[14px] leading-snug" style="color: #79778a;">{position}</p>
            {/if}
            {#if linkedin != null && linkedin !== ""}
                <a href={linkedin} class="text-navy hover:opacity-70 flex-shrink-0" target="_blank" rel="noopener noreferrer">
                    <LinkedinSolid class="w-5 h-5" />
                </a>
            {/if}
            {#if company && name && company_image}
                <div class="mt-2">
                    <img src={company_image} alt={company} class="w-14 h-14 object-contain rounded-lg" style="mix-blend-mode: multiply;" />
                </div>
            {/if}
        </div>
    </div>

    <!-- Right: quote (flex-1) -->
    <div class="flex-1 text-[16px] text-navy leading-relaxed">
        <slot />
    </div>
</div>

<style>
    .highlight {
        color: #050c3b;
    }
</style>
